var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2105 11.6667V12.4444C14.2105 13.3 13.5 14 12.6316 14H1.57895C0.702632 14 0 13.3 0 12.4444V1.55556C0 0.7 0.702632 0 1.57895 0H12.6316C13.5 0 14.2105 0.7 14.2105 1.55556V2.33333H7.10526C6.22895 2.33333 5.52632 3.03333 5.52632 3.88889V10.1111C5.52632 10.9667 6.22895 11.6667 7.10526 11.6667H14.2105ZM7.10526 10.1111H15V3.88889H7.10526V10.1111ZM10.2632 8.16667C9.60789 8.16667 9.07895 7.64556 9.07895 7C9.07895 6.35444 9.60789 5.83333 10.2632 5.83333C10.9184 5.83333 11.4474 6.35444 11.4474 7C11.4474 7.64556 10.9184 8.16667 10.2632 8.16667Z",
    fill: "#0C3094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.fab5a7af2efce9ee33433f3f504ad4fc.svg";
export { ForwardRef as ReactComponent };